<template>
  <product-list
    :productService = productService
    :productComponent = productComponent
    :withActions = true
  ></product-list>
</template>

<script>
  import ProductList from '@/components/Common/Product/ProductList'
  import productSlottingService from '@/services/slotting/product'

  export default {
    components: {
      ProductList
    },
    data () {
      return {
        productService: productSlottingService,
        productComponent: 'SlottingProductSales'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Slotting/Products/Overview.vue